import React from 'react';
import {
  columnName,
  columnTools,
  columnValidationDate,
  hasColumn,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import StandardColumns from '@/components/table/StandardColumns';

const DataManagementDataModelTableColumns = ({ columns }) => (
  <StandardColumns entity="data_model" columns={columns} toolsWidth={1}>
    {hasColumn(columns, columnName) && <UnsortedColumn columnId={columnName} />}
    {hasColumn(columns, columnValidationDate) && <UnsortedColumn colWidth={1} columnId={columnValidationDate} />}
    {hasColumn(columns, columnTools) && <UnsortedColumn colWidth={1} />}
  </StandardColumns>
);

export default DataManagementDataModelTableColumns;
